import store from '../../store'

export function updateUploadProgress(uploadId,progress) {
	store.dispatch({ type: 'UPDATE_UPLOAD_PROGRESS', uploadId,progress })
}


